<template>
  <div class="home pa-10">Welcome to LeanCMS!</div>
</template>

<script>
export default {
  name: 'Home',
  components: {}
};
</script>
